/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */

export const publicId = "corgi1";
export const cloudName = "richardhaines";
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Flex = makeShortcode("Flex");
const Heading = makeShortcode("Heading");
const Text = makeShortcode("Text");
const Link = makeShortcode("Link");
const SimpleGrid = makeShortcode("SimpleGrid");
const Box = makeShortcode("Box");
const Emoji = makeShortcode("Emoji");
const CloudinaryImage = makeShortcode("CloudinaryImage");
const layoutProps = {
  publicId
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Flex direction="column" w="100%" h="500px" bg="brand.background" justify="center" align="center" mdxType="Flex">
      <Heading fontSize={["4xl", "4xl", "6xl"]} fontWeight="normal" color="brand.text" m={[3, 3, null]} align="center" mdxType="Heading">
  This is just a super simple MDX site
      </Heading>
      <Text fontSize="3xl" fontWeight="light" color="brand.text" mt={4} m={[3, 3, null]} align="center" mdxType="Text">
  Its just MDX using Chakra-UI components and bundled with Parcel. Its pretty
  lightweight.
      </Text>
      <Link mt={5} href="https://github.com/molebox/barebones-mdx" isExternal color="brand.text" mdxType="Link">
  github.com/molebox/barebones-mdx
      </Link>
    </Flex>
    <SimpleGrid columns={[1, 2, 3]} spacing={10} p={6} bg="brand.accent" minH="500px" mdxType="SimpleGrid">
      <Flex h="200px" bg="brand.background" p={3} d="column" align="center" boxShadow="-3px 3px 0px 1px hsla(0, 0%, 0%, 0.28)" mdxType="Flex">
  <Box borderWidth={1.5} h="100%" p={3} mdxType="Box">
    <Text color="brand.text" fontSize="xl" lineHeight={1.5} mdxType="Text">
      <Emoji ariaLabel="A lightning bolt" symbol="⚡" mdxType="Emoji" />
      The Chakra- UI components are pre loaded into the MDX files so they do not
      need to be imported, you can just use them.
    </Text>
  </Box>
      </Flex>
      <Flex h="200px" bg="brand.background" p={3} d="column" align="center" boxShadow="-3px 3px 0px 1px hsla(0, 0%, 0%, 0.28)" mdxType="Flex">
  <Box borderWidth={1.5} h="100%" p={3} mdxType="Box">
    <Text color="brand.text" fontSize="xl" lineHeight={1.5} mdxType="Text">
      <Emoji ariaLabel="A compass" symbol="🧭" mdxType="Emoji" />
      Configuring the routes is as easy as creating a new MDX page and adding the
      route and link to the MDXRoutes component
    </Text>
  </Box>
      </Flex>
      <Flex h="200px" bg="brand.background" p={3} d="column" align="center" boxShadow="-3px 3px 0px 1px hsla(0, 0%, 0%, 0.28)" mdxType="Flex">
  <Box borderWidth={1.5} h="100%" p={3} mdxType="Box">
    <Text color="brand.text" fontSize="xl" lineHeight={1.5} mdxType="Text">
      <Emoji ariaLabel="A triangular ruler" symbol="📐" mdxType="Emoji" />
      The base layout of the site can be configured in the MDXLayout component
    </Text>
  </Box>
      </Flex>
      <Flex h="200px" w="200px" bg="brand.background" align="center" justify="center" boxShadow="-3px 3px 0px 1px hsla(0, 0%, 0%, 0.28)" mdxType="Flex">
  <Box mdxType="Box">
    <CloudinaryImage publicId={publicId} boxSize="200px" // transformations={{ height: 0.2, border: "2px_solid_black" }}
          cloudName={cloudName} alt="A lazy image" mdxType="CloudinaryImage" />
  </Box>
      </Flex>
    </SimpleGrid>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
